module.exports = __webpack_public_path__ + "static/media/logo2.2ebed0e1.svg";